module.exports = __webpack_public_path__ + "img/2.ab55c818.jpg";